import React from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
import { whatsappLink } from "../contact";
import "./WhatsAppButton.css";

// Product pages already have their own WhatsApp action (and a mobile bar).
function WhatsAppButton() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/product/")) return null;

  return (
    <motion.a
      className="wa-fab"
      href={whatsappLink("Bonjour Cristal Inox, j'aimerais avoir des informations.")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Discuter sur WhatsApp"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ type: "spring", stiffness: 260, damping: 18, delay: 3.2 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      <FaWhatsapp />
    </motion.a>
  );
}

export default WhatsAppButton;
